(function () {
  var state = { has_transfers: false, has_blanks: false, cart_value: 0, item_count: 0 };
  var initialized = false;
  var popupOpen = false;
  var shownTimestamp = null;
  var lastDismissMethod = null;
  var dismissedEventFired = false;
  var uploading = false;
  var activeXHR = null;
  var selectedFile = null;
  var uploadedSourceUrl = null;
  var uploadClickedFired = false;

  var COOKIE_NAME = "dtf_upsell";
  var COOKIE_DAYS = 1;
  var popupEnvironment = (window.Shopify && window.Shopify.theme &&
    window.Shopify.theme.role === "main") ? "production" : "staging";

  /* ── Helpers ── */

  // Low-level GA4 send: gtag guard + device_type. Used directly for the post-redirect
  // PDP events, which carry an explicit popup_variant from the URL (must NOT be
  // overwritten by that page's own state.ft_view).
  function track(name, params) {
    if (typeof gtag === "undefined") return;
    params.device_type = window.innerWidth <= 767 ? "mobile" : "desktop";
    gtag("event", name, params);
  }

  function fireEvent(name, params) {
    // Free Transfers gated view: tag every popup event with which variant/state showed
    // ("none" = existing view, "new" = version A, "unlocked" = version B).
    params.popup_variant = state.ft_view || "none";
    track(name, params);
  }

  // Conversion value for the FT offer (settable via section setting; default 0) + currency.
  function conversionValue() { return (state.ft_conversion_value && parseFloat(state.ft_conversion_value)) || 0; }
  function conversionCurrency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD"; }

  function elapsedMs() {
    return shownTimestamp ? Date.now() - shownTimestamp : 0;
  }

  function setCookie(name, val, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + "=" + val + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }

  function getCookie(name) {
    var v = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return v ? v.pop() : "";
  }

  /* ── State ── */

  function readStateFromDOM(doc) {
    var el = (doc || document).getElementById("dtf-cart-state");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initState() {
    var parsed = readStateFromDOM();
    if (parsed) state = parsed;
  }

  function refreshState() {
    var sectionKey = getSectionKey();
    if (!sectionKey) return;
    fetch("/cart?sections=" + sectionKey, { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionKey];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var parsed = readStateFromDOM(doc);
        if (parsed) state = parsed;
      })
      .catch(function () {});
  }

  function getSectionKey() {
    var dialog = getDialog();
    if (dialog) return dialog.dataset.sectionId;
    var stateEl = document.getElementById("dtf-cart-state");
    if (stateEl) {
      var parent = stateEl.closest("[data-section-id]") || stateEl.parentElement;
      if (parent && parent.id) return parent.id.replace("shopify-section-", "");
    }
    return "dtf-upsell-popup";
  }

  /* ── Dialog ── */

  function getDialog() {
    return document.getElementById("dtf-upsell-popup");
  }

  function shouldFire() {
    return (
      state.has_blanks === true &&
      state.has_transfers === false &&
      getCookie(COOKIE_NAME) === ""
    );
  }

  function openPopup() {
    var dialog = getDialog();
    if (!dialog) return;

    resetUploadState();
    popupOpen = true;
    dismissedEventFired = false;
    uploadClickedFired = false;
    shownTimestamp = Date.now();
    dialog.showModal();
    document.body.classList.add("dtf-popup-open");
    setCookie(COOKIE_NAME, "1", COOKIE_DAYS);

    fireEvent("dtf_popup_shown", {
      popup_version: "v1",
      popup_environment: popupEnvironment,
      time_on_popup_ms: 0
    });

    // GA4-native promotion impression (feeds GA4's promotion reports).
    fireEvent("view_promotion", {
      promotion_id: "free_transfers",
      promotion_name: "Free Transfers - New Customer Bonus",
      creative_name: state.ft_view || "none"
    });
  }

  function closePopup(method) {
    var dialog = getDialog();
    if (!dialog) return;

    if (uploading) {
      showCancelOverlay();
      lastDismissMethod = method;
      return;
    }

    popupOpen = false;
    dialog.close();
    document.body.classList.remove("dtf-popup-open");
    hideCancelOverlay();

    if (!dismissedEventFired) {
      dismissedEventFired = true;
      fireEvent("dtf_popup_dismissed", {
        dismiss_method: method,
        popup_version: "v1",
        popup_environment: popupEnvironment,
        time_on_popup_ms: elapsedMs()
      });
    }

    lastDismissMethod = null;
    shownTimestamp = null;
  }

  /* ── Upload state machine ── */

  function setUploadState(stateName) {
    var container = getDialog() && getDialog().querySelector(".dtf-popup__upload-state");
    if (container) container.setAttribute("data-state", stateName);
  }

  function resetUploadState() {
    setUploadState("initial");
    selectedFile = null;
    uploadedSourceUrl = null;
    uploading = false;
    if (activeXHR) {
      activeXHR.abort();
      activeXHR = null;
    }
    var dialog = getDialog();
    if (dialog) {
      var fill = dialog.querySelector(".dtf-popup__progress-fill");
      var pct = dialog.querySelector(".dtf-popup__progress-pct");
      var fname = dialog.querySelector(".dtf-popup__progress-filename");
      if (fill) fill.style.width = "0%";
      if (pct) pct.textContent = "0%";
      if (fname) fname.textContent = "";
      var fileInput = dialog.querySelector(".dtf-popup__file-input");
      if (fileInput) fileInput.value = "";
    }
  }

  /* ── Cancel overlay ── */

  function showCancelOverlay() {
    var overlay = getDialog() && getDialog().querySelector(".dtf-popup__cancel-overlay");
    if (overlay) overlay.setAttribute("aria-hidden", "false");
  }

  function hideCancelOverlay() {
    var overlay = getDialog() && getDialog().querySelector(".dtf-popup__cancel-overlay");
    if (overlay) overlay.setAttribute("aria-hidden", "true");
  }

  function confirmCancel() {
    if (activeXHR) {
      activeXHR.abort();
      activeXHR = null;
    }
    uploading = false;
    hideCancelOverlay();
    resetUploadState();
    closePopup("cancel_upload");
  }

  function keepUploading() {
    hideCancelOverlay();
    lastDismissMethod = null;
  }

  /* ── Drag & drop ── */

  function handleDragEnter(e) {
    e.preventDefault();
    if (!uploading) setUploadState("drag-hover");
  }

  function handleDragOver(e) {
    e.preventDefault();
  }

  function handleDragLeave(e) {
    var zone = getDialog() && getDialog().querySelector(".dtf-popup__upload-zone[data-for-state='initial']");
    if (zone && !zone.contains(e.relatedTarget)) {
      if (!uploading) setUploadState("initial");
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    if (uploading) return;
    setUploadState("initial");
    var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) handleFile(file);
  }

  function handleFileSelect(e) {
    var file = e.target.files && e.target.files[0];
    if (file) handleFile(file);
  }

  /* ── File validation ── */

  var ACCEPTED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf",
    "image/svg+xml",
    "application/postscript",
    "application/illustrator"
  ];

  var ACCEPTED_EXTENSIONS = ["png", "jpg", "jpeg", "pdf", "svg", "ai"];
  var MAX_SIZE_BYTES = 50 * 1024 * 1024;

  function getFileExtension(name) {
    var parts = (name || "").split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }

  function isAcceptedType(file) {
    if (ACCEPTED_TYPES.indexOf(file.type) !== -1) return true;
    return ACCEPTED_EXTENSIONS.indexOf(getFileExtension(file.name)) !== -1;
  }

  function handleFile(file) {
    if (!isAcceptedType(file)) {
      var ext = getFileExtension(file.name).toUpperCase() || "Unknown";
      showTypeError(ext);
      fireEvent("dtf_popup_upload_failed", {
        error_type: "wrong_type",
        popup_version: "v1",
        popup_environment: popupEnvironment,
        time_on_popup_ms: elapsedMs()
      });
      return;
    }

    if (file.size > MAX_SIZE_BYTES) {
      setUploadState("error-size");
      fireEvent("dtf_popup_upload_failed", {
        error_type: "too_large",
        popup_version: "v1",
        popup_environment: popupEnvironment,
        time_on_popup_ms: elapsedMs()
      });
      return;
    }

    selectedFile = file;
    startUpload(file);
  }

  function showTypeError(ext) {
    setUploadState("error-type");
    var dialog = getDialog();
    if (dialog) {
      var detail = dialog.querySelector('[data-for-state="error-type"] .dtf-popup__error-detail');
      if (detail) detail.textContent = ext + " isn’t supported. Try PNG, JPG, PDF, SVG or AI.";
    }
  }

  /* ── Upload ── */

  var PRESIGN_API = "https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production/uploads/getPresignedUploadUrl";
  var S3_BUCKET = "https://ninja-services-production-ninjauploadss3bucket-zks2mguobhe4.s3.amazonaws.com/";

  function startUpload(file) {
    uploading = true;
    setUploadState("uploading");

    var dialog = getDialog();
    if (dialog) {
      var fname = dialog.querySelector(".dtf-popup__progress-filename");
      if (fname) fname.textContent = file.name;
    }

    fireEvent("dtf_popup_upload_started", {
      popup_version: "v1",
      popup_environment: popupEnvironment,
      time_on_popup_ms: elapsedMs()
    });

    var randomName = file.name.split(".")[0]
      .replace(/[^a-z0-9\s]/gi, "")
      .replace(/[_\s]/g, "-") + "____" +
      "image_" + Date.now() + "_" + Math.floor(Math.random() * 1000) + "." +
      file.name.split(".").pop();

    var fileType = file.type || "application/octet-stream";

    getPresignedUrl(randomName, fileType)
      .then(function (presignData) {
        if (!presignData || !presignData.url) {
          throw new Error("No presigned URL returned");
        }
        uploadToS3(presignData.url, file, randomName, fileType, presignData.sourceUrl, false);
      })
      .catch(function () {
        uploading = false;
        setUploadState("error-network");
        fireEvent("dtf_popup_upload_failed", {
          error_type: "network",
          popup_version: "v1",
          popup_environment: popupEnvironment,
          time_on_popup_ms: elapsedMs()
        });
      });
  }

  function getPresignedUrl(fileName, fileType) {
    return fetch(PRESIGN_API + "?file_name=" + encodeURIComponent(fileName) + "&file_type=" + encodeURIComponent(fileType))
      .then(function (r) {
        if (!r.ok) throw new Error("Presign API returned " + r.status);
        return r.json();
      });
  }

  function uploadToS3(presignedUrl, file, remoteName, fileType, sourceUrl, isRetry) {
    var xhr = new XMLHttpRequest();
    activeXHR = xhr;

    xhr.open("PUT", presignedUrl, true);

    xhr.upload.addEventListener("progress", function (e) {
      if (e.lengthComputable) {
        var pct = Math.round((e.loaded / e.total) * 100);
        updateProgress(pct);
      }
    });

    xhr.onload = function () {
      activeXHR = null;
      if (xhr.status === 200) {
        uploading = false;
        uploadedSourceUrl = sourceUrl;
        setUploadState("success");
        updateProgress(100);

        var fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        fireEvent("dtf_popup_upload_completed", {
          file_type: getFileExtension(file.name),
          file_size_mb: parseFloat(fileSizeMB),
          value: conversionValue(),
          currency: conversionCurrency(),
          popup_version: "v1",
          popup_environment: popupEnvironment,
          time_on_popup_ms: elapsedMs()
        });

        // GA4-native conversion (mark as a Key Event in GA4).
        fireEvent("generate_lead", {
          value: conversionValue(),
          currency: conversionCurrency(),
          popup_version: "v1"
        });

        setTimeout(function () {
          fireEvent("dtf_popup_redirected_to_pdp", {
            popup_version: "v1",
            popup_environment: popupEnvironment,
            time_on_popup_ms: elapsedMs()
          });
          window.location.href = "/products/dtf-transfers?file=" + encodeURIComponent(sourceUrl) +
            "&src=dtf_popup&variant=" + encodeURIComponent(state.ft_view || "none");
        }, 1200);
      } else if (xhr.status === 403 && !isRetry) {
        getPresignedUrl(remoteName, fileType)
          .then(function (presignData) {
            if (!presignData || !presignData.url) {
              throw new Error("No presigned URL returned");
            }
            uploadToS3(presignData.url, file, remoteName, fileType, presignData.sourceUrl, true);
          })
          .catch(function () {
            uploading = false;
            setUploadState("error-network");
            fireEvent("dtf_popup_upload_failed", {
              error_type: "presign_expired",
              popup_version: "v1",
              popup_environment: popupEnvironment,
              time_on_popup_ms: elapsedMs()
            });
          });
      } else {
        uploading = false;
        setUploadState("error-network");
        fireEvent("dtf_popup_upload_failed", {
          error_type: "upload_http_" + xhr.status,
          popup_version: "v1",
          popup_environment: popupEnvironment,
          time_on_popup_ms: elapsedMs()
        });
      }
    };

    xhr.onerror = function () {
      activeXHR = null;
      uploading = false;
      setUploadState("error-network");
      fireEvent("dtf_popup_upload_failed", {
        error_type: "network",
        popup_version: "v1",
        popup_environment: popupEnvironment,
        time_on_popup_ms: elapsedMs()
      });
    };

    xhr.send(file);
  }

  function updateProgress(pct) {
    var dialog = getDialog();
    if (!dialog) return;
    var fill = dialog.querySelector(".dtf-popup__progress-fill");
    var pctEl = dialog.querySelector(".dtf-popup__progress-pct");
    if (fill) fill.style.width = pct + "%";
    if (pctEl) pctEl.textContent = pct + "%";
  }

  /* ── Event binding ── */

  // Engagement: user clicked to upload (intent) before choosing a file. Once per open.
  function trackUploadClicked() {
    if (uploadClickedFired) return;
    uploadClickedFired = true;
    fireEvent("dtf_popup_upload_clicked", {
      popup_version: "v1",
      popup_environment: popupEnvironment,
      time_on_popup_ms: elapsedMs()
    });
    fireEvent("select_promotion", {
      promotion_id: "free_transfers",
      promotion_name: "Free Transfers - New Customer Bonus",
      creative_name: state.ft_view || "none"
    });
  }

  function bindDialogEvents() {
    var dialog = getDialog();
    if (!dialog) return;
    if (dialog.dataset.dtfBound) return;
    dialog.dataset.dtfBound = "1";

    var closeBtns = dialog.querySelectorAll(".dtf-popup__close");
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener("click", function () { closePopup("x_button"); });
    }

    var skipLink = dialog.querySelector(".dtf-popup__skip");
    if (skipLink) {
      skipLink.addEventListener("click", function (e) {
        e.preventDefault();
        closePopup("no_thanks");
        window.location.href = "/checkout";
      });
    }

    dialog.addEventListener("cancel", function (e) {
      e.preventDefault();
      closePopup("esc");
    });

    dialog.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        closePopup("esc");
      }
    });

    var uploadZone = dialog.querySelector('.dtf-popup__upload-zone[data-for-state="initial"]');
    if (uploadZone) {
      uploadZone.addEventListener("dragenter", handleDragEnter);
      uploadZone.addEventListener("dragover", handleDragOver);
      uploadZone.addEventListener("dragleave", handleDragLeave);
      uploadZone.addEventListener("drop", handleDrop);
    }

    var browseLinks = dialog.querySelectorAll(".dtf-popup__browse-link");
    for (var b = 0; b < browseLinks.length; b++) {
      browseLinks[b].addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        trackUploadClicked();
        var fi = dialog.querySelector(".dtf-popup__file-input");
        if (fi) fi.click();
      });
    }

    var fileInput = dialog.querySelector(".dtf-popup__file-input");
    if (fileInput) fileInput.addEventListener("change", handleFileSelect);

    var retryBtns = dialog.querySelectorAll(".dtf-popup__error-retry");
    for (var r = 0; r < retryBtns.length; r++) {
      retryBtns[r].addEventListener("click", function () {
        resetUploadState();
        var fi = dialog.querySelector(".dtf-popup__file-input");
        if (fi) fi.click();
      });
    }

    var cancelConfirm = dialog.querySelector(".dtf-popup__cancel-confirm");
    if (cancelConfirm) cancelConfirm.addEventListener("click", confirmCancel);

    var cancelKeep = dialog.querySelector(".dtf-popup__cancel-keep");
    if (cancelKeep) cancelKeep.addEventListener("click", keepUploading);
  }

  /* ── Init ── */

  // Post-redirect conversion tracking — runs on /products/dtf-transfers?src=dtf_popup
  // (this section/JS loads on every page, so no separate PDP template edit is needed).
  function setupConversionTracking() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (!qs || qs.get("src") !== "dtf_popup") return;
    var variant = qs.get("variant") || "none";

    // Landed: the redirect successfully reached the DTF transfers PDP.
    track("dtf_popup_landed", {
      popup_variant: variant,
      popup_version: "v1",
      popup_environment: popupEnvironment
    });

    // True conversion: first cart change after landing = the transfer added. Fire once.
    var addedFired = false;
    function fireTransferAdded() {
      if (addedFired) return;
      addedFired = true;
      var v = conversionValue(), cur = conversionCurrency();
      track("dtf_popup_transfer_added", {
        popup_variant: variant,
        value: v,
        currency: cur,
        popup_version: "v1",
        popup_environment: popupEnvironment
      });
      track("add_to_cart", { popup_variant: variant, value: v, currency: cur, src: "dtf_popup" });
    }
    document.addEventListener("cart-updated", fireTransferAdded);
    var cf = document.querySelectorAll("cart-form");
    for (var i = 0; i < cf.length; i++) { cf[i].addEventListener("cart-updated", fireTransferAdded); }
  }

  function init() {
    if (initialized) return;
    initialized = true;
    initState();
    bindDialogEvents();
    setupConversionTracking();

    /* One show only (Owen 9-18, blanks-popup family fix). The upload-success
       path deliberately navigates to the DTF PDP with the dialog still OPEN
       (the 1.2s "sending" beat is the transition). Safari's back/forward
       cache snapshots the page with the open dialog, so Back from the PDP
       resurrected the popup frozen in its post-upload state — a second show
       the dtf_upsell cookie cannot prevent because nothing re-fired it.
       pageshow fires on every restore; close the leftover dialog there.
       No-op on fresh loads and on engines that skip bfcache. */
    window.addEventListener("pageshow", function () {
      var d = getDialog();
      if (d && d.hasAttribute("open")) {
        d.close();
        document.body.classList.remove("dtf-popup-open");
      }
    });

    $(document).on("click", '[href="/checkout"]:not(.skipchk)', function (e) {
      if (!getDialog()) return;
      if (!shouldFire()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openPopup();
    });

    document.addEventListener("cart-updated", refreshState);
    var cartForms = document.querySelectorAll("cart-form");
    for (var i = 0; i < cartForms.length; i++) {
      cartForms[i].addEventListener("cart-updated", refreshState);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
